<template>
  <div :class="['mobile-hero-intro', `mobile-hero-intro--${variant}`]">
    <div class="mobile-hero-intro__sub" v-if="serial || subtitle">
      <span v-if="serial" class="mobile-hero-intro__serial">{{ serial }}</span>
      <span v-if="serial" class="mobile-hero-intro__slash">/</span>
      <span v-if="subtitle">{{ subtitle }}</span>
      <i v-if="subtitle"></i>
    </div>
    <div class="mobile-hero-intro__title">
      <div class="mobile-hero-intro__title-black">{{ titleBlack }}</div>
      <div class="mobile-hero-intro__title-purple">{{ titlePurple }}</div>
    </div>
    <div class="mobile-hero-intro__desc">
      <div
        v-for="(item, index) in descList"
        :key="index"
        class="mobile-hero-intro__desc-line"
        v-html="item"
      >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHeroIntro',
  props: {
    variant: {
      type: String,
      default: 'hero'
    },
    serial: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: '悬赏招聘'
    },
    titleBlack: {
      type: String,
      default: '人不到面，'
    },
    titlePurple: {
      type: String,
      default: '不花一分钱。'
    },
    desc: {
      type: [String, Array],
      default: () => [
        '发布悬赏，AI 全网找人；',
        '入职再结算，没结果全额退。'
      ]
    }
  },
  computed: {
    descList() {
      return Array.isArray(this.desc) ? this.desc : [this.desc]
    }
  }
}
</script>

<style lang="less" scoped>
.mobile-hero-intro__sub {
  display: flex;
  align-items: center;
  gap: 13px;
  color: #7C50FF;
  font-size: 28px;
  font-weight: 700;

  i {
    display: block;
    width: 80px;
    height: 1px;
    background: #7C50FF;
    border-radius: 999px;
  }
}

.mobile-hero-intro__serial,
.mobile-hero-intro__slash {
  flex-shrink: 0;
}

.mobile-hero-intro__title {
  margin-top: 12px !important;
  font-size: 60px;
  line-height: 1;
  font-weight: 800;
}

.mobile-hero-intro__title-black {
  color: #222222;
}

.mobile-hero-intro__title-purple {
  color: #7C50FF;
}

.mobile-hero-intro__desc {
  margin-top: 32px;
  font-size: 32px;
  line-height: 44px;
  color: #222222;
}

.mobile-hero-intro__desc-line + .mobile-hero-intro__desc-line {
  margin-top: 4px;
}

.mobile-hero-intro--section {
  .mobile-hero-intro__sub {
    gap: 14px;
    color: #7E86A7;
    font-size: 24px;
    font-weight: 700;

    i {
      width: 150px;
      background: #A8ACC1;
    }
  }

  .mobile-hero-intro__title {
    margin-top: 34px;
    font-size: 56px;
    line-height: 1.08;
  }

  .mobile-hero-intro__desc {
    margin-top: 36px;
    font-size: 28px;
    font-weight: 500;
  }
}
</style>
